module.exports = __webpack_public_path__ + "static/logo-naira@2x-9a3425b7cf43d6362c7c91e03c89a4ac.png";